//packages
import React, { useState, useEffect } from "react";
import { withRouter, useLocation, useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import { includes, map, get } from "lodash";
import { openSuccessPopup } from "../../Redux/Actions/PopupActions";
import { openFailDialog } from "../../Redux/Actions/PopupActions";
// Utils
import {
  getFromLocalStorage,
  removeFromLocalStorage,
  setInToLocalStorage,
} from "../../utils/webStorage";
//Material Ui
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import CssBaseline from "@material-ui/core/CssBaseline";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import { FaAngleDown, FaAngleRight } from "react-icons/fa";
import { AiFillWarning } from "react-icons/ai";
import blankProfile from "./images/blank-profile.png";
// Assets
import schoolAdminLogo from "../../assets/images/schoolAdminLogo.png";
import setting from "../../assets/images/setting.png";
import successimg from "../../assets/images/successimg.png";
import {
  schoolAdminList,
  coachesList,
  athleteList,
} from "../../data/SchoolAdminPortalData";
import MobileNavbar from "../schoolAdminPortal/MobileNavbar";
import "../schoolAdminPortal/schoolAdmin.css";
import userService from "../../services/user.service";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import SchoolAdminDialog from "./Popups/SchoolAdminDialog";
import { useDispatch, useSelector } from "react-redux";
import BlankProfile from "./images/blank-profile.png";
import {
  userRoleKeyMap,
  userRoles,
  userSchoolName,
} from "../../utils/constant";
import { removeDeletedVideos } from "../../Redux/Actions/StorageManagementActions";
import {
  setDrawerOpen,
  setIsMobileDevice,
  setSchoolAdminProfileImage,
} from "../../Redux/Actions/SchoolAdminDashboardAction";
import { useSchoolDashboardMenuListHook } from "../../data/useSchoolDashboardMenuListHook";
import ResetPasswordDialog from "./Popups/ResetPasswordDialog";
import ProfileSection from "./ProfileSection";
import {
  disconnectSocket,
  getSocket,
  initializeSocket,
} from "../../utils/socket";
import { setSocketConnection } from "../../Redux/Actions/SocketActions";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    width: "100%",
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.easeInOut,
      duration: 1000,
    }),
  },
  drawerPaper: {
    width: drawerWidth,
    color: "#575757",
    zIndex: 11,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.easeInOut,
      duration: 1000,
    }),
  },

  drawerContainer: {
    overflow: "auto",
  },
  dropdownbutton: {
    margin: theme.spacing(1),
    color: "#575757",
    borderRadius: "22px",
    width: "80%",
    fontFamily: "Rajdhani-SemiBold",
  },

  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },

  dropdown: {
    position: "absolute",
    right: 0,
    left: "8px",
    zIndex: 1,
    padding: theme.spacing(0, 1),
    // backgroundColor: '#003594',
    width: "80%",
    // top: '100px',
    color: "#575757",
    borderRadius: "22px",
    textAlign: "center",
    fontFamily: "Rajdhani-SemiBold",
  },
  innerdropdown: {
    color: "#575757",
    fontFamily: "Rajdhani-SemiBold",
    background: "#E0E0E0",
  },
  grow: {
    flexGrow: 1,
    textAlign: "right",
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },

  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  tabs: {
    // background: '#003594'
  },

  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
}));

const MiniDrawer = (props) => {
  const [open, setOpen] = useState(false);
  const lolcation = useLocation();
  const [UserName, setUserName] = useState(null);
  const [adminRole, setadminRole] = useState(null);
  const [schoolName, setschoolName] = useState(null);
  const [schoolLogoShow, setschoolLogoShow] = useState(null);
  const [opendialog, setOpendialog] = useState(false);
  const [coachId, setCoachId] = useState(null);
  const [schoolNo, setSchoolNo] = useState(null);
  const [schoolDetails, setSchoolDetails] = useState([]);
  const [schoolId, setSchoolId] = useState(null);
  const [unReadCount, setUnReadCount] = useState(null);
  const [showBillingMsg, setShowBillingMsg] = useState("");
  const [shortBilingMsg, setShortBilingMsg] = useState("");
  const [billingMsgFlag, showBillingMsgFlag] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [openReset, setOpenReset] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [assignedRights, setAssignedRights] = useState([]);
  const [manageList, setManageList] = useState();
  const [isOpen, setIsOpen] = useState(true);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery("(min-width:600px) and (max-width:1024px)");
  const { isMobileDevice } = useSelector(
    (state) => state?.schoolAdminDashboardInformation
  );
  const userInfo = useSelector(({ loggedInUser }) => {
    const role = loggedInUser.role;
    const user = loggedInUser[userRoleKeyMap[role]];
    return {
      role: role,
      profileImage: user.uploadedLogo
        ? user.uploadedLogo.filePath
        : blankProfile,
      userName: user.firstName + " " + user.lastName,
      schoolDetails:
        role == userRoles.ROLE_SCHOOL_ADMIN
          ? user
          : user[userSchoolName[role]][0].school,
    };
  });
  const { maxLibraryPage } = useSelector((state) => state?.videoLibraryData);
  const { isDrawerOpen } = useSelector(
    (state) => state?.schoolAdminDashboardInformation
  );
  const classes = useStyles({ isDrawerOpen });
  const user = JSON.parse(getFromLocalStorage("user"));
  const userId = getFromLocalStorage("currentUserId");
  const { firstName, lastName } = useSelector(
    (state) => state?.loggedInUser?.userProfile
  );

  const sidebarMenuList = useSchoolDashboardMenuListHook();
  const dispatch = useDispatch();

  const submitResetPassword = async (values, setSubmitting) => {
    setSubmitting(true);
    const { oldPassword, password, confirmPassword } = values;
    setOpenReset(false);
    userService
      .resetPasswordSuperAdmin(oldPassword, password, confirmPassword)
      .then((response) => {
        setSubmitting(false);
        openSuccessPopup(dispatch, {
          successPopUp: {
            message: "Password changed successfully.",
            open: true,
          },
        });
        logout();
      })
      .catch((error) => {
        openFailDialog(dispatch, {
          open: true,
          message: "Something went wrong!",
        });
      });
    setSubmitting(false);
  };

  const handleClickCloseSucess = () => {
    setOpenSuccess(false);
  };

  const { history } = props;
  // for popup
  const openDialog = () => {
    setOpendialog(true);
  };
  const closeDialog = () => {
    setOpendialog(false);
  };

  const loadDataOnlyOnce = () => {
    userService
      .getCoachSchoolDetails(coachId)
      .then((response) => {
        var arr = response.data.data;
        if (arr !== null) {
          setSchoolDetails(arr.schools);
          setSchoolNo(arr.length);
        }
      })
      .catch((error) => {
        console.error("There was an error Solve!", error);
      });
  };

  const loadDataOnlyNotification = () => {
    setSubmitting(true);
    userService
      .getNotificationData()
      .then((response) => {
        var data = response.data.data;
        setUnReadCount(data.unreadCount);
        setSubmitting(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  const handleToCloseReset = () => {
    setOpenReset(false);
  };

  useEffect(() => {
    if (user?.accessToken && userId && schoolId && firstName && !getSocket()) {
      // Initialize socket connection only if it doesn't already exist
      const socket = initializeSocket(
        user.accessToken,
        userId,
        schoolId,
        `${firstName} ${lastName}`
      );

      // Store socket in Redux or context
      setSocketConnection(dispatch, socket);
    }

    // Cleanup on unmount
    return () => {
      disconnectSocket();
      setSocketConnection(dispatch, null);
    };
  }, [user?.accessToken, userId, schoolId, firstName, lastName, dispatch]);

  useEffect(() => {
    var UserName = getFromLocalStorage("loginUser");
    var adminRole = getFromLocalStorage("loginRole");
    var schoolLogoShow = getFromLocalStorage("schoolLogo");
    var coachId = getFromLocalStorage("coachId");
    var schoolId = getFromLocalStorage("schoolId");
    const assignedRights = JSON.parse(
      getFromLocalStorage("assignedRights") || []
    );
    const assignedRightsIds = assignedRights.map((item) => item.displayName);
    setAssignedRights(assignedRightsIds);
    setUserName(UserName);
    setadminRole(adminRole);
    setschoolName(schoolName);
    setschoolLogoShow(schoolLogoShow);
    setCoachId(coachId);
    setSchoolId(schoolId);
    checkManagelist(adminRole);
  }, []);

  useEffect(() => {
    adminRole === "SCHOOL ADMIN" &&
      schoolId &&
      userService.getSchoolDetails(schoolId).then((res) => {
        const schoolAdminProfileUrl = res.data.data.user?.profileUrl?.filePath;
        setSchoolAdminProfileImage(
          dispatch,
          schoolAdminProfileUrl ? schoolAdminProfileUrl : ""
        );
      });
  }, [adminRole, schoolId]);

  const checkManagelist = (role) => {
    switch (role) {
      case "SCHOOL ADMIN":
        setManageList(schoolAdminList);

        break;

      case "COACH":
        setManageList(coachesList);
        break;

      case "ATHELETE":
        setManageList(athleteList);

        break;

      case "TEAM_ADMIN":
        setManageList(schoolAdminList);

      default:
        break;
    }
  };

  useEffect(() => {
    var schoolId = getFromLocalStorage("schoolId");
    var coachRole = getFromLocalStorage("loginRole");
    loadDataOnlyOnce();
    loadDataOnlyNotification();
    if (coachRole != "COACH" && coachRole != "ATHLETE") {
      getLiveDueDates(schoolId);
    }
  }, []);

  const currentRoute = useHistory().location.pathname.toLowerCase();

  const getLiveDueDates = (schoolId) => {
    userService
      .getBillingDetailsCheck(schoolId)
      .then((response) => {
        var msgCount1 = getFromLocalStorage("billingShowHideFlag");
        if (response.data.data == "" || response.data.data == null) {
          showBillingMsgFlag(false);
        } else {
          setShowBillingMsg(response.data.data.split(","));
          setShortBilingMsg(response.data.data.split(","));
          showBillingMsgFlag(true);
          setInToLocalStorage("billingShowHideFlag", true);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  const closebillingMsgShow = () => {
    setShowBillingMsg("");
    showBillingMsgFlag(false);
  };

  const switchSchool = (id, name, logo) => {
    setSchoolId(id);
    setschoolName(name);
    setschoolLogoShow(logo);
    localStorage.setItem("schoolId", id);
    localStorage.setItem("schoolName", name);
    localStorage.setItem("schoolLogo", logo);
    window.location.reload();
  };

  useEffect(() => {
    setIsMobileDevice(dispatch, isMobile);
  }, [isMobile]);

  function logout() {
    removeFromLocalStorage("user");
    removeDeletedVideos(dispatch, {});
    window.localStorage.clear();
    history.push("/login");
  }
  const handleClickAway = () => {
    setOpen(false);
  };

  const toggleDrawer = () => {
    setDrawerOpen(dispatch, !isDrawerOpen);
  };

  const drawerMenuClick = (path) => {
    history.push(path);
    if (isMobileDevice) {
      setDrawerOpen(dispatch, !isDrawerOpen);
    }
  };

  return (
    <div className="mobileScroll">
      <div id="hideSAdminDash" className={classes.root}>
        <CssBaseline />
        <AppBar position="fixed" className={classes.appBar} id="userProfile">
          <MobileNavbar />
          <Toolbar>
            <div>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={toggleDrawer}
              >
                <MenuIcon />
              </IconButton>
              <Link to="/SchoolAdminData">
                <img
                  src={schoolAdminLogo}
                  alt="Logo"
                  className="cz-img"
                  nowrap="true"
                />
              </Link>
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            </div>
            <div className="nav-center">
              {billingMsgFlag && (
                <div className="orangeboxheader">
                  <AiFillWarning style={{ fontSize: "18px" }} />
                  <p className="fs-16 medium text-light">{showBillingMsg[0]}</p>
                  <Link to="/billingDetails" className="v-details">
                    View Details
                  </Link>
                  <button
                    className="dismiss-btn"
                    onClick={() => closebillingMsgShow()}
                  >
                    Dismiss
                  </button>
                </div>
              )}
            </div>
            <ProfileSection />
          </Toolbar>
        </AppBar>
        <ResetPasswordDialog
          submitResetPassword={submitResetPassword}
          openReset={openReset}
          handleToCloseReset={handleToCloseReset}
        />
        <Dialog
          id="ChnagePassSucess"
          open={openSuccess}
          onClose={handleClickCloseSucess}
        >
          <DialogTitle>
            <div className="row">
              <div className="col-1 text-right ml-auto "></div>
            </div>
          </DialogTitle>
          <DialogContent>
            <div className="row">
              <div className="col-12 text-center">
                <img
                  src={successimg}
                  alt="success"
                  className="successimg-new"
                ></img>
                <div className="clear20"></div>
                <p className="fs-20 semi-bold text-center">
                  Password changed successfully.
                </p>
                <div className="clear30"></div>
              </div>
              <div className="col-12 col-md-12 col-lg-12 ml-auto text-center">
                <Link>
                  <button type="button" class="donebtn canBtn" onClick={logout}>
                    DONE
                  </button>
                </Link>
              </div>
            </div>

            <div className="clear10"></div>

            <div className="clear10"></div>
          </DialogContent>
        </Dialog>

        {!includes(
          [
            "/uploadvideos",
            "/profileManagement",
            "/selectedvideos",
            "/videolibrary",
            "/videomerge",
            "/intercutVideo",
            "/cameras",
            "/CreateHighlight",
            "/highlightmerge",
            "/pdfTronhome",
            "/intercutvideo",
          ],
          get(lolcation, "pathname")
        ) ? (
          <Drawer
            id="schoolAdminSidebar"
            classes={{
              paper: classes.drawerPaper,
            }}
            style={{
              display: maxLibraryPage ? "none" : "initial",
            }}
            variant={"persistent"}
            open={isDrawerOpen}
            onClose={toggleDrawer}
            anchor="left"
          >
            <div className="clear40"></div>
            <div className={classes.drawerContainer}>
              <div className="row brd-bottom-light">
                <div className="d-flex-align-cent gap-10 padding-10 mt-30 mtt-3">
                  <div className="school-logo-dashboard">
                    <img
                      className="school-logo-dashboard"
                      src={
                        userInfo.schoolDetails.uploadedLogo
                          ? userInfo.schoolDetails.uploadedLogo.filePath
                          : BlankProfile
                      }
                      alt="School"
                    />
                  </div>
                  <h6 className="fs-18 semi-bold black school-name">
                    {userInfo.schoolDetails.schoolName}
                  </h6>
                </div>
              </div>

              {coachId && schoolNo > 1 && (
                <span
                  className="cp fs-16 txtulstyle regular ml-3"
                  onClick={openDialog}
                >
                  Switch School
                </span>
              )}
              <List>
                {map(sidebarMenuList, (item, index) => {
                  const path = get(item, "path");
                  const liname = get(item, "liname");
                  return (
                    <div className="h-40" id="schoolFeed" key={index}>
                      <ListItem
                        id={item.text}
                        className={
                          currentRoute.includes(liname)
                            ? "li-active"
                            : "Dashboard-listt-items"
                        }
                        button
                        onClick={() => drawerMenuClick(path)}
                      >
                        {item.icon && (
                          <ListItemIcon className="font-25 mg-right-5">
                            {item.icon}
                          </ListItemIcon>
                        )}
                        <ListItemText primary={item.text} />
                      </ListItem>
                    </div>
                  );
                })}
              </List>

              <hr className="mb-0 mt-0" />
              <ClickAwayListener onClickAway={handleClickAway}>
                <div id="schoolAdminButton" className={classes.root}>
                  {adminRole !== "ATHLETE" && (
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 pt-3">
                      <div
                        className="d-flex-alig-cent cp"
                        onClick={() => setIsOpen(!isOpen)}
                      >
                        <p className="d-flex-align-cent">
                          <img className="ml-4" src={setting} alt="set"></img>
                          <span className="fs-18 semi-bold mg-bottom-0">
                            &nbsp;&nbsp;&nbsp;Manage
                          </span>
                          {isOpen ? (
                            <FaAngleRight className="dropdown-icon" />
                          ) : (
                            <FaAngleDown className="dropdown-icon" />
                          )}
                        </p>
                      </div>

                      <div
                        className={
                          !isOpen
                            ? "manage-collapse-section"
                            : "manage-collapse-section show"
                        }
                      >
                        <List>
                          {map(manageList, (item, index) => {
                            const path = get(item, "path");
                            const liname = get(item, "liname");
                            return (
                              <div
                                className="manage-section-menu-itemss w-100"
                                id="schoolFeed"
                                key={index}
                              >
                                <ListItem
                                  id={item.text}
                                  className={
                                    currentRoute.includes(liname)
                                      ? "li-active"
                                      : "Dashboard-listt-items"
                                  }
                                  button
                                  onClick={() => {
                                    if (isMobileDevice) {
                                      setDrawerOpen(dispatch, !isDrawerOpen);
                                    }
                                    history.push(path);
                                  }}
                                >
                                  <div className="padin-60 w-100 d-flex-align-cent ">
                                    {item.icon && (
                                      <ListItemIcon className="mng-icons2">
                                        {item.icon}
                                      </ListItemIcon>
                                    )}
                                    <ListItemText primary={item.text} />
                                  </div>
                                </ListItem>
                              </div>
                            );
                          })}
                        </List>
                      </div>
                    </div>
                  )}
                </div>
              </ClickAwayListener>
            </div>
          </Drawer>
        ) : null}

        <SchoolAdminDialog
          opendialog={opendialog}
          closeDialog={closeDialog}
          schoolDetails={schoolDetails}
          switchSchool={switchSchool}
          schoolName={"KKR"}
        />
      </div>
    </div>
  );
};

export default withRouter(MiniDrawer);
